export default __webpack_public_path__ + "static/media/aws.d5156378.svg";